import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import QAmountField from 'components/QAmountField';
import InvestmentTransactionBaseForm from './InvestmentTransactionBaseForm';

const InvestmentTransactionSharesForm = (props) => {
  const { formik, expectedSign = -1 } = props;

  const [pricePerUnit, setPricePerUnit] = useState();

  useEffect(() => {
    formik.registerField('amount', { validate: (value) => (value ? undefined : 'please enter valid amount') });
    formik.registerField('units', {
      validate: (value) => (typeof value === 'number' && value ? undefined : 'field is required'),
    });
    return () => {
      formik.unregisterField('amount');
      formik.unregisterField('units');
    };
  }, [formik]);

  useEffect(() => {
    const amount = typeof formik.values.amount === 'number' ? Math.abs(formik.values.amount) : 0;
    const commission = formik.values.commission || 0;
    const units = typeof formik.values.units === 'number' ? Math.abs(formik.values.units) : 0;
    if (amount !== 0 && units) {
      const newPricePerUnit = Math.abs((amount - expectedSign * commission) / units);
      if (pricePerUnit !== newPricePerUnit) {
        setPricePerUnit(newPricePerUnit);
      }
    }
  }, [formik, formik.values.amount, formik.values.units, formik.values.commission, expectedSign, pricePerUnit]);

  return (
    <>
      <InvestmentTransactionBaseForm formik={formik} />

      <Box display='flex' alignItems='center' gap={1}>
        <QAmountField
          id='total-amount'
          editable
          label='Total Amount'
          sx={{ minWidth: 110 }}
          noNegatives
          value={Math.abs(formik.values.amount)}
          onChange={(event) => formik.setFieldValue('amount', expectedSign * Math.abs(Number(event.target.value)))}
          error={Boolean(formik.submitCount > 0 && formik.errors.amount)}
          helperText={(formik.submitCount > 0 && formik.errors.amount) || ''}
        />
        =
        <TextField
          id='units'
          label='Shares quantity'
          type='number'
          inputProps={{ min: 1 }}
          sx={{ minWidth: 110 }}
          value={formik.values.units != null ? Math.abs(formik.values.units) : ''}
          onChange={(event) =>
            formik.setFieldValue('units', event.target.value ? expectedSign * Number(event.target.value) : null)
          }
          error={Boolean(formik.submitCount > 0 && formik.errors.units)}
          helperText={(formik.submitCount > 0 && formik.errors.units) || ''}
        />
        x
        <QAmountField
          id='price-per-share'
          sx={{ minWidth: 110, marginBottom: 1 }}
          expectedSign='positive'
          value={pricePerUnit}
          label='Price per share'
        />
        {expectedSign > 0 ? '-' : '+'}
        <QAmountField
          id='commission'
          editable
          sx={{ minWidth: 110 }}
          value={formik.values.commission}
          onChange={(event) => formik.setFieldValue('commission', Number(event.target.value))}
          label='Commission'
          error={Boolean(formik.submitCount > 0 && formik.errors.commission)}
          helperText={(formik.submitCount > 0 && formik.errors.commission) || ''}
        />
      </Box>
    </>
  );
};

InvestmentTransactionSharesForm.propTypes = {
  formik: PropTypes.object.isRequired,
  expectedSign: PropTypes.number, // +1 or -1
};

export default InvestmentTransactionSharesForm;
